import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import FeedImageSlider from 'components/community/components/feed/FeedImageSlider';
import { calculateTimeStamp } from 'utils';
import { useRouter } from 'next/router';

var BranchFeedCard = function BranchFeedCard(_ref) {
  var feed = _ref.feed;
  var branch = feed.branch;
  var router = useRouter();

  var clickFeed = function clickFeed() {
    router.push("/branch/post/".concat(feed.id));
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "inbox",
    children: [/*#__PURE__*/_jsx("div", {
      className: "photo-w",
      children: /*#__PURE__*/_jsx(FeedImageSlider, {
        images: feed.images,
        onImageClick: clickFeed
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "info",
      onClick: clickFeed,
      style: {
        cursor: 'pointer'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tit",
        children: [/*#__PURE__*/_jsx("strong", {
          children: branch.name
        }), /*#__PURE__*/_jsx("span", {
          children: calculateTimeStamp(feed.created_at)
        })]
      }), /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: feed.content
        }
      })]
    })]
  });
};

export default BranchFeedCard;